export const discount = {
  discountType: {
    campaign: "Campaign",
    loss: "Financial Loss",
  },
};
